export const URLS = {
  NEXT_AIM_UZ: 'https://next.aim.uz',
  TEST_AIM_UZ: 'https://test.aim.uz',
  AKAM_UZ: 'https://akam.uz',
}
